import { ClientCredentials } from '@modules/auth/interfaces';
import { createAction, props } from '@ngrx/store';

/* local */
// log in with local auth
export const LOGIN_WITH_LOCAL = '[Authentication] Log In With Local';
export const LOGIN_WITH_LOCAL_FAIL = '[Authentication] Log In With Local Fail';
export const LOGIN_WITH_LOCAL_SUCCESS = '[Authentication] Log In With Local Success';

export const LogInWithLocal = createAction(LOGIN_WITH_LOCAL, props<{ payload: ClientCredentials }>());
export const LogInWithLocalFail = createAction(LOGIN_WITH_LOCAL_FAIL, props<{ payload: Error }>());
export const LogInWithLocalSuccess = createAction(LOGIN_WITH_LOCAL_SUCCESS, props<{ payload: any }>());

// log out with local auth
export const LOGOUT_WITH_LOCAL = '[Authentication] Log Out With Local';
export const LOGOUT_WITH_LOCAL_SUCCESS = '[Authentication] Log Out With Local Success';
export const LOGOUT_WITH_LOCAL_FAIL = '[Authentication] Log Out With Local Fail';

export const LogOutWithLocal = createAction(LOGOUT_WITH_LOCAL);
export const LogOutWithLocalSuccess = createAction(LOGOUT_WITH_LOCAL_SUCCESS);
export const LogOutWithLocalFail = createAction(LOGOUT_WITH_LOCAL_FAIL);

/* parse */
// log in
export const LOGIN = '[Authentication] Log in';
export const LOGIN_FAIL = '[Authentication] Log in Fail';
export const LOGIN_SUCCESS = '[Authentication] Log in Success';

export const LogIn = createAction(LOGIN, props<{ payload: ClientCredentials }>());
export const LogInFail = createAction(LOGIN_FAIL, props<{ payload: Error }>());
export const LogInSuccess = createAction(LOGIN_SUCCESS, props<{ payload: any }>());

// log in with session
export const LOGIN_WITH_SESSION = '[Authentication] Log in with Session';
export const LOGIN_WITH_SESSION_FAIL = '[Authentication] Log in  with Session Fail';
export const LOGIN_WITH_SESSION_SUCCESS = '[Authentication] Log in with Session Success';

export const LogInWithSession = createAction(LOGIN_WITH_SESSION, props<{ payload: string }>());
export const LogInWithSessionFail = createAction(LOGIN_WITH_SESSION_FAIL, props<{ payload: Error }>());
export const LogInWithSessionSuccess = createAction(LOGIN_WITH_SESSION_SUCCESS, props<{ payload: any }>());

// log out
export const LOGOUT = '[Authentication] Logout';

export const LogOut = createAction(LOGOUT);

/* supabase */
// log in with supabase
export const LOGIN_WITH_SUPABASE = '[Authentication] Log in with Supabase';
export const LOGIN_WITH_SUPABASE_FAIL = '[Authentication] Log in  with Supabase Fail';
export const LOGIN_WITH_SUPABASE_SUCCESS = '[Authentication] Log in with Supabase Success';

export const LogInWithSupabase = createAction(LOGIN_WITH_SUPABASE, props<{ payload: string }>());
export const LogInWithSupabaseFail = createAction(LOGIN_WITH_SUPABASE_FAIL, props<{ payload: Error }>());
export const LogInWithSupabaseSuccess = createAction(LOGIN_WITH_SUPABASE_SUCCESS, props<{ payload: any }>());

// log out with supabase
export const LOGOUT_WITH_SUPABASE = '[Authentication] Log out with Supabase';

export const LogOutWithSupabase = createAction(LOGOUT_WITH_SUPABASE);

// reset auth state
export const RESET_AUTH_STATE = '[Authentication] Reset Auth State';

export const ResetAuthState = createAction(RESET_AUTH_STATE);

// refresh tokens
export const REFRESH_TOKENS = '[Authentication] Refresh Tokens';

export const RefreshTokens = createAction(
    REFRESH_TOKENS,
    props<{ payload: { accessToken: string; refreshToken: string } }>()
);

// action types
export type AuthAction =
    | typeof RefreshTokens
    | typeof LogInWithLocal
    | typeof LogInWithLocalFail
    | typeof LogInWithLocalSuccess
    | typeof LogOutWithLocal
    | typeof LogOutWithLocalSuccess
    | typeof LogOutWithLocalFail
    | typeof LogIn
    | typeof LogInFail
    | typeof LogInSuccess
    | typeof LogOut
    | typeof LogInWithSession
    | typeof LogInWithSessionFail
    | typeof LogInWithSessionSuccess
    | typeof LogInWithSupabase
    | typeof LogInWithSupabaseFail
    | typeof LogInWithSupabaseSuccess
    | typeof ResetAuthState;
